import React, { useState } from "react";
import MainToolbar from "../MainToolbar";
import {
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableHead,
  TableBody,
  makeStyles,
  IconButton,
  Paper,
} from "@material-ui/core";
import t from "../common/localization";
import { useEffectAsync } from "../reactHelper";
import EditCollectionView from "../EditCollectionView";
import { formatBoolean, formatPosition } from "../common/formatter";
import EditIcon from "@material-ui/icons/Edit";
import ClearIcon from "@material-ui/icons/Clear";
import { green, blue, red, grey } from "@material-ui/core/colors";
import Avatar from "@material-ui/core/Avatar";
import { showLoaderStateActions } from "./../store";
import { useDispatch, useSelector } from "react-redux";
import SearchBar from "material-ui-search-bar";

const useStyles = makeStyles((theme) => ({
  columnAction: {
    width: theme.spacing(1),
    padding: theme.spacing(0, 1),
  },
  tableAction: {
    backgroundColor: "white",
  },
  rowAction: {
    backgroundColor: "#361DDB",
  },
  iconButtons: {
    marginLeft: "auto",
    display: "flex",
  },
  small: {
    width: theme.spacing(4),
    height: theme.spacing(4),
    backgroundColor: "#EFEFEF",
    margin: "2px",
  },
  tCell: {
    color: "white",
    backgroundColor: "#361DDB",
  },
  tContainer: {
    maxHeight: 730,
  },
}));

const ComputedAttributes = ({
  updateTimestamp,
  handleOnEdit,
  handleOnRemove,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [successDialogShow, setSuccessDialogShow] = useState(false);

  const [items, setItems] = useState([]);
  const [searchList, setSearchList] = useState([]);

  useEffectAsync(async () => {
    dispatch(showLoaderStateActions.addState(true));

    const response = await fetch("/api/attributes/computed");
    dispatch(showLoaderStateActions.addState(false));

    if (response.ok) {
      const res = await response.json();
      setItems(res);
      setSearchList(res);
    }
  }, [updateTimestamp]);

  const filterItems = searchList.sort(
    (a, b) =>
      new Date(b.creationTime).getTime() - new Date(a.creationTime).getTime()
  );

  return (
    <>
      <TableContainer className={classes.tContainer} component={Paper}>
        <Table
          stickyHeader
          aria-label="sticky table"
          className={classes.tableAction}
          size="small"
          style={{ whiteSpace: "nowrap" }}
        >
          <TableHead>
            <TableRow className={classes.rowAction}>
              <TableCell className={classes.tCell}>{"Description"}</TableCell>
              <TableCell className={classes.tCell}>{"Attribute"}</TableCell>
              <TableCell className={classes.tCell}>{"Expression"}</TableCell>
              <TableCell className={classes.tCell}>{"Type"}</TableCell>
              <TableCell className={classes.tCell}>{"Vendor"}</TableCell>
              <TableCell className={classes.tCell}> </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filterItems.map((item) => (
              <TableRow hover key={item.id} className={classes.tableRow}>
                <TableCell>{<b>{item.description}</b>}</TableCell>
                <TableCell>{<b>{item.attribute}</b>}</TableCell>
                <TableCell>{<b>{item.expression}</b>}</TableCell>
                <TableCell>{item.type}</TableCell>
                <TableCell>{item.vendor}</TableCell>
                <TableCell className={classes.columnAction} padding="none">
                  <div className={classes.iconButtons}>
                    <Avatar className={classes.small}>
                      {
                        <IconButton onClick={() => handleOnEdit(item.id)}>
                          <EditIcon
                            fontSize="small"
                            style={{ color: blue[600] }}
                          />
                        </IconButton>
                      }
                    </Avatar>
                    <Avatar className={classes.small}>
                      {
                        <IconButton onClick={() => handleOnRemove(item.id)}>
                          <ClearIcon
                            fontSize="small"
                            style={{ color: grey[450] }}
                          />
                        </IconButton>
                      }
                    </Avatar>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

const ComputedAttributesPage = () => {
  return (
    <>
      <MainToolbar />
      <EditCollectionView
        content={ComputedAttributes}
        editPath="/computedattributes"
        endpoint="attributes/computed"
        successDialogShow={false}
      />
    </>
  );
};

export default ComputedAttributesPage;
